import { UsersManagement } from 'pages/users';
import { useUserManagementData } from './useUserManagementData';

export const UserManagement: React.FC = () => {
  const { users, organizations, roles, isLoading, isError, errorMessage } =
    useUserManagementData();
  return (
    <UsersManagement
      users={users}
      organizations={organizations}
      roles={roles}
      isLoading={isLoading}
      isError={isError}
      errorMessage={errorMessage}
    />
  );
};
